import http from '@/utils/services/http'

export function list (limit, page, filtros) {
  return http.get('/api/policiacivil/notificacao-atendimento/?page=' + page + '&limit=' + limit + filtros)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function listByGrv (grvId) {
  return http.get(`/api/policiacivil/notificacao-atendimento/grv/${grvId}`)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function cadastrar (data, id = null) {
  if (id) return update(data, id)
  return http.post('/api/policiacivil/notificacao-atendimento', JSON.stringify(data))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function find (id) {
  id = parseInt(id)
  if (id < 1) return Promise.reject()
  return http.get('/api/policiacivil/notificacao-atendimento/' + id)
    .then(response => {
      console.log(response)
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function update (data, id) {
  return http.patch('/api/policiacivil/notificacao-atendimento/' + id + '/update', JSON.stringify(data))
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function deleteAtendimento (id) {
  return http.delete('/api/policiacivil/notificacao-atendimento/' + id)
    .then(response => {
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}

export function gerarPdfAtendimento (id) {
  return http.get(`/api/grv/atendimento/${id}/emitir-notificacao-presencial-recuperacao`, {responseType: 'blob'})
    .then(response => {
      console.log(response)
      return Promise.resolve(response)
    })
    .catch(({response}) => {
      return Promise.reject(response)
    })
}



// WEBPACK FOOTER //
// ./src/domain/policia-civil/notificacao-atendimento/services/notificacao-atendimento.js